import { IPlan } from "../../interfaces/api";
import DoctorsDrugsTile from "./DoctorsDrugsTile.component";

const DoctorsDrugs = ({ data }: { data: IPlan }) => {
  return (
    <div
      className="grid-x grid-margin-x"
      style={{ padding: "16px 40px 23px", borderBottom: "1px solid  #F5F9FD" }}
    >
      <DoctorsDrugsTile planData={data} />
    </div>
  );
};

export default DoctorsDrugs;
